import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { SetStudentsVisitForLessonPayload } from "../../payload/SetStudentsVisitForLesson/SetStudentsVisitForLessonPayload";

const setStudentsVisitForLessonFetch = (state: GroupsState, action: PayloadAction<SetStudentsVisitForLessonPayload>) => {
    state.isLoading = true;
}

export default setStudentsVisitForLessonFetch;